import React from 'react';
import InfoPin from './InfoPin';

// The Bridge of Consensus — a high-end matte-white span across the Amazon at the
// map's centre, matching the research fleet. Wide enough for the SUV to turn on.
export default function Bridge() {
  const white = <meshStandardMaterial color="#f2f2ee" metalness={0.05} roughness={0.62} flatShading />;
  const gold = <meshStandardMaterial color="#D4AF37" metalness={0.9} roughness={0.2} emissive="#D4AF37" emissiveIntensity={0.25} />;
  const DECK_W = 18;   // wide deck (turnaround room)
  const DECK_L = 52;   // spans the river and reaches both banks

  return (
    <group position={[0, 0, 0]}>
      {/* Deck */}
      <mesh position={[0, 0.05, 0]} receiveShadow castShadow>
        <boxGeometry args={[DECK_W, 0.7, DECK_L]} />
        {white}
      </mesh>
      {/* Gold edge trims */}
      {[-DECK_W / 2 + 0.4, DECK_W / 2 - 0.4].map((x, i) => (
        <mesh key={i} position={[x, 0.45, 0]}>
          <boxGeometry args={[0.5, 0.2, DECK_L]} />
          {gold}
        </mesh>
      ))}
      {/* Railings: posts + top rail on both sides */}
      {[-DECK_W / 2 + 0.5, DECK_W / 2 - 0.5].map((x, s) => (
        <group key={s}>
          <mesh position={[x, 1.4, 0]}>
            <boxGeometry args={[0.14, 0.12, DECK_L]} />
            {white}
          </mesh>
          {Array.from({ length: 13 }).map((_, i) => (
            <mesh key={i} position={[x, 0.9, -DECK_L / 2 + 2 + i * (DECK_L - 4) / 12]}>
              <boxGeometry args={[0.12, 1.0, 0.12]} />
              {white}
            </mesh>
          ))}
        </group>
      ))}
      {/* Pylons into the water */}
      {[-14, -4, 4, 14].map((z, i) => (
        <group key={i}>
          <mesh position={[-DECK_W / 2 + 1.4, -3, z]}>
            <cylinderGeometry args={[0.7, 0.9, 8, 10]} />
            {white}
          </mesh>
          <mesh position={[DECK_W / 2 - 1.4, -3, z]}>
            <cylinderGeometry args={[0.7, 0.9, 8, 10]} />
            {white}
          </mesh>
        </group>
      ))}
      {/* Center arch accent */}
      <mesh position={[0, 3.4, 0]}>
        <boxGeometry args={[DECK_W + 1.2, 0.3, 1.2]} />
        {gold}
      </mesh>
      {/* Gold Info Pin instead of large floating signage (respects Hide Panels). */}
      <InfoPin position={[0, 4, 0]} y={7} title="Bridge of Consensus" subtitle="the only crossing between the banks" seed={3} />
    </group>
  );
}
